import { render, staticRenderFns } from "./StockTaking.vue?vue&type=template&id=13e17ab8&scoped=true"
import script from "./StockTaking.vue?vue&type=script&lang=js"
export * from "./StockTaking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e17ab8",
  null
  
)

export default component.exports